import { render, staticRenderFns } from "./TitledSubsection.vue?vue&type=template&id=1b76353c&scoped=true&"
import script from "./TitledSubsection.vue?vue&type=script&lang=ts&"
export * from "./TitledSubsection.vue?vue&type=script&lang=ts&"
import style0 from "./TitledSubsection.vue?vue&type=style&index=0&id=1b76353c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b76353c",
  null
  
)

export default component.exports